<template>
  <div class="c-announcement" v-if="displayBanner">
    <image-loader :image-id="displayBanner.file_id" />

    <article>
      <h2>{{ displayBanner.title }}</h2>
      <p>
        {{ displayBanner.description }}
      </p>
      <base-button @click="handleClick" primary="true">{{
        displayBanner.button_text
      }}</base-button>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageLoader from "@/components/elements/ImageLoader.vue";
export default {
  name: "AnnouncementWidget",
  components: { ImageLoader },
  async mounted() {
    let resp;
    resp = await this.$store.dispatch("widgets/announcements/setBanner", {
      bannerId: this.banner,
    });
    this.displayBanner = resp;
    this.loading = false;
  },
  methods: {
    handleClick() {
      if (this.displayBanner.link_url) {
        return window.open(this.displayBanner.link_url);
      }

      // if the resource is a document or policy
      if (this.displayBanner.resource.current_version) {
        // eforms are different too
        if (this.displayBanner.resource.self.includes("eformmanagement")) {
          // account for if url starts with a slash or not
          const url =
            this.displayBanner.resource.eform_url.substr(0, 1) == "/"
              ? this.displayBanner.resource.eform_url
              : `/${this.displayBanner.resource.eform_url}`;
          return this.$router.push({
            path: `/forms${url}`,
          });
        }
        if (this.displayBanner.resource.self.includes("survey")) {
          // account for if url starts with a slash or not
          const url =
            this.displayBanner.resource.survey_url.substr(0, 1) == "/"
              ? this.displayBanner.resource.survey_url
              : `/${this.displayBanner.resource.survey_url}`;
          return this.$router.push({
            path: `/survey${url}`,
          });
        }
        const docId = this.displayBanner.resource.id;
        const docType = this.displayBanner.resource.self.includes("policy")
          ? "policies"
          : "forms";
        return this.$router.push({ path: `/documents/${docType}/${docId}` });
      }

      // if we are a file
      if (this.displayBanner.resource.file_hash) {
        this.$store
          .dispatch("files/read", this.displayBanner.resource.id)
          .then((resp) => {
            return this.$store.dispatch("files/download", resp);
          });

        return;
      }

      this.$router.push({ path: `/${this.displayBanner.resource.self}` });
    },
  },
  data() {
    return {
      heroImageSrc: null,
      loading: true,
      displayBanner: null,
    };
  },
  props: {
    banner: {
      type: [String, Number],
      default: null,
    },
  },

  watch: {
    banner(newValue, oldValue) {
      this.$store.dispatch("widgets/announcements/setBanner", {bannerId: newValue});
    },
  },
};
</script>

<style lang="scss" scoped>
.c-announcement {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  min-height: 350px;

  article {
    bottom: 0;
    box-sizing: border-box;
    color: $colour-nhs-core-white;
    padding: 10px;
    position: absolute;
    width: 100%;
    z-index: 1;
    &:before {
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.37) 100%
      );
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }
  }

  img {
    position: absolute;
    width: 150%;
    z-index: 1;

    height: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @supports (object-fit: cover) {
      object-fit: cover;
      height: 100%;
    }
  }
}
</style>
